module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-green-medium-d44bd4146f2a4c8e7aef749d40311589.svg";